import { Visitable } from './Visitable';
import { Visitor } from './Visitor';

export default class Contact implements Visitable {

    private _email: string;
    private _name: string;
    private _phone: string;

    constructor(name: string, email: string, phone: string) {
        this._email = email;
        this._name = name;
        this._phone = phone;
    }

    get name(): string {
        return this._name;

    }

    get email(): string {
        return this._email;
    }

    get phone(): string {
        return this._phone;
    }

    accept(visitor: Visitor): void {
        visitor.visitContact(this);
    }
}